export const updateEntityContextMutation = () => {
    return `
    mutation UpdateEntityContext(
        $entityContextId: Int!,
        $bucketName: String,
        $ITEmail: String,
        $environmentsUrl: JSONString,
        $whitelistDepartments: JSONString,
        $whitelistApprovers: JSONString,
        $keyFinancialFoldersList: JSONString,
        $keyFinancialFoldersWhitelistDepartments: JSONString,
        $keyFinancialFoldersWhitelistUsers: JSONString,
        $keyFinancialFoldersWhitelistDepartmentsColumnName: JSONString,
        $githubRepos: JSONString,
        $gitlabProjects: JSONString,
        $jiraProjects: JSONString,
        $domains: JSONString,
        $hrAdminGroups: JSONString,
        $administrationActivitiesAdminsWhitelist: JSONString,
        $administrationActivitiesCriticalActivitiesBlacklist: JSONString,
        $mongodbCredentials: JSONString,
        $flowDependency: JSONString,
        $jobsBlacklistUsers: JSONString,
        $jobsBlacklistRoles: JSONString,
        $weekendDays: JSONString,
        $scytaleCompanyId: ObjectIdString
    ) {
        updateEntityContext(
            entityContextId: $entityContextId,
            bucketName: $bucketName,
            ITEmail: $ITEmail,
            environmentsUrl: $environmentsUrl,
            whitelistDepartments: $whitelistDepartments,
            whitelistApprovers: $whitelistApprovers,
            keyFinancialFoldersList: $keyFinancialFoldersList,
            keyFinancialFoldersWhitelistDepartments: $keyFinancialFoldersWhitelistDepartments,
            keyFinancialFoldersWhitelistUsers: $keyFinancialFoldersWhitelistUsers,
            keyFinancialFoldersWhitelistDepartmentsColumnName: $keyFinancialFoldersWhitelistDepartmentsColumnName,
            githubRepos: $githubRepos,
            gitlabProjects: $gitlabProjects,
            jiraProjects: $jiraProjects,
            domains: $domains,
            hrAdminGroups: $hrAdminGroups,
            administrationActivitiesAdminsWhitelist: $administrationActivitiesAdminsWhitelist,
            administrationActivitiesCriticalActivitiesBlacklist: $administrationActivitiesCriticalActivitiesBlacklist,
            mongodbCredentials: $mongodbCredentials,
            flowDependency: $flowDependency,
            jobsBlacklistUsers: $jobsBlacklistUsers,
            jobsBlacklistRoles: $jobsBlacklistRoles,
            weekendDays: $weekendDays,
            scytaleCompanyId: $scytaleCompanyId
        ) {
            entityContext {
                id
                bucketName
                ITEmail
                environmentsUrl
                whitelistDepartments
                whitelistApprovers
                keyFinancialFoldersList
                keyFinancialFoldersWhitelistDepartments
                keyFinancialFoldersWhitelistUsers
                keyFinancialFoldersWhitelistDepartmentsColumnName
                githubRepos
                gitlabProjects
                jiraProjects
                domains
                hrAdminGroups
                administrationActivitiesAdminsWhitelist
                administrationActivitiesCriticalActivitiesBlacklist
                mongodbCredentials
                flowDependency
                jobsBlacklistUsers
                jobsBlacklistRoles
                weekendDays
                scytaleCompanyId
                createdAt
                updatedAt
                entity {
                    name
                }
            }
        }
    }
    `
}

export const createEntityContextMutation = () => {
    return `
    mutation CreateEntityContext(
        $entityId: Int!,
        $bucketName: String,
        $ITEmail: String,
        $environmentsUrl: JSONString,
        $whitelistDepartments: JSONString,
        $whitelistApprovers: JSONString,
        $keyFinancialFoldersList: JSONString,
        $keyFinancialFoldersWhitelistDepartments: JSONString,
        $keyFinancialFoldersWhitelistUsers: JSONString,
        $keyFinancialFoldersWhitelistDepartmentsColumnName: JSONString,
        $githubRepos: JSONString,
        $gitlabProjects: JSONString,
        $jiraProjects: JSONString,
        $domains: JSONString,
        $hrAdminGroups: JSONString,
        $administrationActivitiesAdminsWhitelist: JSONString,
        $administrationActivitiesCriticalActivitiesBlacklist: JSONString,
        $mongodbCredentials: JSONString,
        $flowDependency: JSONString,
        $jobsBlacklistUsers: JSONString,
        $jobsBlacklistRoles: JSONString,
        $weekendDays: JSONString
    ) {
        createEntityContext(
            entityId: $entityId,
            bucketName: $bucketName,
            ITEmail: $ITEmail,
            environmentsUrl: $environmentsUrl,
            whitelistDepartments: $whitelistDepartments,
            whitelistApprovers: $whitelistApprovers,
            keyFinancialFoldersList: $keyFinancialFoldersList,
            keyFinancialFoldersWhitelistDepartments: $keyFinancialFoldersWhitelistDepartments,
            keyFinancialFoldersWhitelistUsers: $keyFinancialFoldersWhitelistUsers,
            keyFinancialFoldersWhitelistDepartmentsColumnName: $keyFinancialFoldersWhitelistDepartmentsColumnName,
            githubRepos: $githubRepos,
            gitlabProjects: $gitlabProjects,
            jiraProjects: $jiraProjects,
            domains: $domains,
            hrAdminGroups: $hrAdminGroups,
            administrationActivitiesAdminsWhitelist: $administrationActivitiesAdminsWhitelist,
            administrationActivitiesCriticalActivitiesBlacklist: $administrationActivitiesCriticalActivitiesBlacklist,
            mongodbCredentials: $mongodbCredentials,
            flowDependency: $flowDependency,
            jobsBlacklistUsers: $jobsBlacklistUsers,
            jobsBlacklistRoles: $jobsBlacklistRoles,
            weekendDays: $weekendDays
        ) {
            entityContext {
                id
                bucketName
                ITEmail
                environmentsUrl
                whitelistDepartments
                whitelistApprovers
                keyFinancialFoldersList
                keyFinancialFoldersWhitelistDepartments
                keyFinancialFoldersWhitelistUsers
                keyFinancialFoldersWhitelistDepartmentsColumnName
                githubRepos
                gitlabProjects
                jiraProjects
                domains
                hrAdminGroups
                administrationActivitiesAdminsWhitelist
                administrationActivitiesCriticalActivitiesBlacklist
                mongodbCredentials
                flowDependency
                jobsBlacklistUsers
                jobsBlacklistRoles
                weekendDays
                createdAt
                updatedAt
                entity {
                    name
                }
            }
        }
    }
    `
}
